// extracted by mini-css-extract-plugin
module.exports = {"root":"xX7K0","bottomTextWrapper":"Uwddd","section":"_2IBb5","carouselContainer":"_2PEmv"};